module.exports = __webpack_public_path__ + "static/media/apple.5467d7c3.svg";